import React, {Fragment} from 'react';
import Icon from './Icon';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import classNames from 'classnames';
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";

class Button extends React.Component {

    static defaultProps = {
        privileges: [],
        privilegesType: "or",
        privilegeVisible: false
    }

    static propTypes = {
        tag: PropTypes.any,
        type: PropTypes.string,
		color: PropTypes.string,
        disabled: PropTypes.bool,
        focus: PropTypes.bool,
		onClick: PropTypes.func,
        onMouseDown: PropTypes.func,
        onMouseUp: PropTypes.func,
        onMouseMove: PropTypes.func,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        icon: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(Icon.propTypes)]),
        tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(Tooltip.propTypes)]),
        className: PropTypes.any,
		block: PropTypes.bool,
        flat: PropTypes.string,
        size: PropTypes.string,
        privileges: PropTypes.array,
        privilegesType: PropTypes.oneOf(["and", "or"]),
        privilegeVisible: PropTypes.bool
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.focus) {
            this.button && this.button.focus();
        }
    }

    componentDidMount() {
        if (this.props.focus) {
            this.button && this.button.focus();
        }
    }

    render() {
        let disabled = false;
        let privilegeVisible = true;
        if (!!this.props.privileges.length) {
            const privileges = [];
            this.props.user.privileges.map((p) => {
                if (this.props.privileges.indexOf(p.name) !== -1) {
                    privileges.push(p.name);
                }
            });
            if (this.props.privilegesType === "or") {
                disabled = privileges.length === 0;
            } else if (this.props.privilegesType === "and") {
                disabled = privileges.length < this.props.privileges.length;
            }
            privilegeVisible = this.props.privilegeVisible;
            if (disabled && !privilegeVisible) {
                return null;
            }
        }
        if (!disabled) {
            disabled = this.props.disabled;
        }
        const { className } = this.props;
        let tooltip = {};
        if (typeof(this.props.tooltip) === "object" && !(this.props.tooltip || {}).props) {
            tooltip = {...(this.props.tooltip || {}), position: (this.props.tooltip || {}).position || "top", disabled: (this.props.tooltip || {}).disabled || disabled};
        } else {
            const html = this.props.tooltip instanceof Function ? this.props.tooltip() : this.props.tooltip;
            tooltip = {position: "top", disabled: disabled};
            if (html) {
                tooltip.html = html;
            } else {
                tooltip = {};
            }
        }
        let icon = {};
        if (this.props.icon instanceof Object) {
            icon = {...this.props.icon, position: this.props.icon.position || "left", disabled: this.props.icon.disabled || disabled};
        } else {
            icon = {name: this.props.icon, position: "left", disabled: disabled};
        }
        const icontag = this.props.icon && <Icon {...icon} />;
        const Tag = this.props.tooltip ? Tooltip : Fragment;
        const ButtonTag = this.props.tag || "button";
        const type = this.props.type || "button";

        const props = {...this.props};
        delete props['privilegesType'];
        delete props['privilegeVisible'];
        delete props['block'];

        return <ButtonTag
            ref={(button) => this.button = button}
            {...props}
            type={type}
            className={classNames("button btn", className, {"tooltip-holder": !!this.props.tooltip, ["btn-" + this.props.size || ""]: this.props.size, "btn-flat": this.props.flat, "btn-block": this.props.block, disabled, ["btn-" + this.props.color]: this.props.color})}
            onClick={ disabled || !this.props.onClick ? null : this.props.onClick }
        >
			<Tag {...(this.props.tooltip ? tooltip : {})}>
				{icon.position === "left" && <Fragment>{icontag} </Fragment>}
				{this.props.children}
				{icon.position === "right" && <Fragment> {icontag}</Fragment>}
			</Tag>
        </ButtonTag>;
	}
}

export default connect((state) => {
    return {
        user: state.app.user
    };
}, {})(Button);